import { writable } from 'svelte/store';

// Skapa en store för hasBeenVoted
export const hasBeenVoted = writable(false);

export const hasplayedonce = writable(false);

export const answers = writable([]);

export const toplistL = writable(3);

export const listOfSelectedMelodies = writable([]);

